<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #TEST="{row}">
      <Select
        v-if="row"
        :placeholder="$t('select') + $t('currencyName')"
        @on-change="SelChange"
        v-model="row.currency_id"
        filterable
      >
        <Option
          v-for="(option, index) in options"
          :value="option.id"
          :key="index"
          :disabled="option.disabled"
          >{{ option.code }}</Option
        >
      </Select>
    </template>
  </cTable>
</template>

<script>
import {
  getList,
  add,
  del,
  update,
  getDetails,
  getConfig,
	log,
} from "@/api/finance/channelCost";
import { getFinaDivision } from "@/api/system/city";
import cTable from "@/base/common/index";
import { getCountry } from "@/api/system/country";
import { getCurrency } from "@/api/finance/currency";
import { getAgent } from "@/api/tracker/agent";
import { getSelectType } from "@/api/public";
export default {
  name: "channelCost",
  components: {
    cTable
  },
  data() {
    let that = this;
    return {
      options: [],
      methods: {
        list: getList,
        getDetails,
        del,
        add,
        update,
        getCountry,
        getCurrency,
				log,
        getFinaDivision
      },
      config: {
        height: 630
      },
      modals: {
				showDetails: {
				  config: {
				    listFn: "log",
				    modalBind: {
				      width: 80,
				      transfer: true,
				      draggable: true,
				      sticky: true,
				      "reset-drag-position": true,
				      styles: {
				        top: "30px",
				      },
				    },
				    rowBind: {
				      gutter: 16,
				      style: {
				        marginBottom: "20px",
				      },
				    },
				    formBind: {},
				  },
					footer:{
						show:()=>false
					},
				  table: {
				    config: {
				      height: 750,
				    },
				    footer: {
				      show: true,
				    },
				    fields: [
							{
							  name: () => this.$t("operate"),
							  key: "operate_name",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("operation") + this.$t("time"),
							  key: "operate_time",
							  width: 170,
							},
				      {
				        name: () => this.$t("operation") + this.$t("content"),
				        key: "operate_content",
				        minWidth: 100,
								render(h,data){
									return h('div',{domProps: {
											innerHTML: data.row.operate_content // 这里是要渲染的数据
									}})
								}
				      },
				      {
				        name: () => this.$t("operation") + this.$t("type"),
				        key: "type_txt",
				        minWidth: 80,
				      },
							{
							  name: () => this.$t("clientName"),
							  key: "client_name",
							  minWidth: 80,
							},
							
				    ],
				  },
				},
        add: {
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data["continued"] = JSON.parse(JSON.stringify(this.list));
              this.$page
                .handleRequestMethods(this.type, data, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 1200,
              draggable: true,
              styles: {
                top: "30px"
              }
            },
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;"
            },
            formBind: {
              labelWidth: 140
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              agent_id: [
                {
                  required: true,
                  message: "agent_id cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              from_country: [
                {
                  required: true,
                  message: "from_country cannot be empty",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "to_country cannot be empty",
                  trigger: "change"
                }
              ],
              division: [
                {
                  required: true,
                  message: "division cannot be empty",
                  type: "number",
                  trigger: "change"
                }
              ],
              cod_type: [
                {
                  required: true,
                  message: "cod_type cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              pod_type: [
                {
                  required: true,
                  message: "pod_type cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              currency: [
                {
                  required: true,
                  message: "currency cannot be empty",
                  trigger: "change"
                }
              ],
              first_weight: [
                {
                  required: false,
                  message: "first_weight cannot be empty",
                  trigger: "blur"
                }
              ],
              first_weight_price: [
                {
                  required: false,
                  message: "planName cannot be empty",
                  trigger: "blur"
                }
              ],
              values_limit: [
                {
                  required: true,
                  message: "values_limit cannot be empty",
                  trigger: "blur"
                }
              ],
              values_rate: [
                {
                  required: true,
                  message: "values_rate cannot be empty",
                  trigger: "blur"
                }
              ],
              ddp_price: [
                {
                  required: true,
                  message: "ddp_price cannot be empty",
                  trigger: "blur"
                }
              ],
              title: [
                {
                  required: true,
                  message: "ddp_price cannot be empty",
                  trigger: "blur"
                }
              ],
              start_time: [
                {
                  required: true,
                  message: "ddp_price cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ],
              end_time: [
                {
                  required: true,
                  message: "ddp_price cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [
            {
              name: () => this.$t("basic_information"),
              span: 24,
              children: [
                {
                  title: 8,
                  start_time: 8,
                  end_time: 8
                },
                {
                  agent_id: 8,
                  from_country: 8,
                  to_country: 8
                },
                {
                  division: 8,
                  cod_type: 8,
                  pod_type: 8
                },
                {
                  currency: 8,
                  first_weight: 8,
                  first_weight_price: 8
                },
                {
                  isCharges: 8,
                  is_special: 8
                },
                {
                  values_limit: 8,
                  values_rate: 8,
                  ddp_price: 8
                }
              ]
            },
            {
              name: () => this.$t("additional_information"),
              span: 24,
              children: [
                {
                  air_price: 8,
                  destroy_price: 8,
                  send_price: 8
                },
                {
                  vat_fee_rate: 8,
                  airway_price: 8,
                  extract_price: 8
                },
                {
                  extract_type: 8,
                  remarks: 16
                }
              ]
            }
          ],
          fields: [
            {
              name: () => this.$t("costName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("costName");
              }
            },
            {
              key: "start_time",
              name: () => this.$t("enableTime"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("enableTime"),
              bind: {
                clearable: false,
                type: "datetime",
                style: {
                  width: "100%"
                }
              },
              disabledDate: true
              // methods: {
              //   "on-change"({ formData }) {
              //     formData.start_time = formData.start_time
              //       ? this.$page.format.timeFormat(formData.start_time)
              //       : "";
              //   }
              // }
            },
            {
              key: "end_time",
              name: () => this.$t("deadline"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("deadline"),
              bind: {
                clearable: false,
                type: "datetime",
                style: {
                  width: "100%"
                }
              },
              disabledDate: true
              // methods: {
              //   "on-change"({ formData }) {
              //     formData.end_time = formData.end_time
              //       ? this.$page.format.timeFormat(formData.end_time)
              //       : "";
              //   }
              // }
            },
            {
              name: () => this.$t("agentName"),
              key: "agent_id",
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("agentName");
              },
              options: [],
              config: { label: "agent_name", value: "id" }
            },
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("from_country");
              },
              options: [],
              config: { label: "code", value: "code" }
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("target_country");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                "on-change"({ row, fields, value }) {
                  fields.forEach(async item => {
                    if (item.key == "division") {
                      row["division"] = "";
                      if (value) {
                        item.options = (
                          await this.$page.handleRequestMethods(
                            "getFinaDivision",
                            { country: value }
                          )
                        ).payload;
                      } else {
                        item.options = [];
                      }
                    }
                    this.$forceUpdate();
                  });
                }
              }
            },
            {
              name: () => this.$t("division"),
              key: "division",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("division");
              },
              options: []
            },
            {
              name: () => this.$t("cod_type_txt"),
              key: "cod_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("cod_type_txt");
              },
              options: []
            },
            {
              name: () => this.$t("pod_type_txt"),
              key: "pod_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("pod_type_txt");
              },
              options: []
            },
            {
              name: () => this.$t("billingCurrency"),
              key: "currency",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("billingCurrency");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("firstWeight"),
              key: "first_weight",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("firstWeight");
              }
            },
            {
              name: () => this.$t("firstWeightFreight"),
              key: "first_weight_price",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("firstWeightFreight");
              }
            },
            {
              name: () => this.$t("isAdditionalCharges"),
              key: "isCharges",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              bind: {
                border: true
              },
              placeholder() {
                return this.$t("enter") + this.$t("isAdditionalCharges");
              },
              methods: {
                "on-change": ({ value }) => {
                  console.log(value);
                }
              },
              default: 0
            },
            {
              name: () => this.$t("whether") + this.$t("specialRule"),
              key: "is_special",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              bind: {
                border: true
              },
              placeholder() {
                return this.$t("enter") + this.$t("specialRule");
              },
              methods: {
                "on-change": ({ value }) => {
                  console.log(value);
                }
              },
              default: 0
            },
            {
              name: () => this.$t("declared_value"),
              key: "values_limit",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              show: ({ formData }) => {
                if (formData.isCharges == 1) {
                  return true;
                }
              },
              placeholder() {
                return this.$t("enter") + this.$t("declared_value");
              }
            },
            {
              name: () => this.$t("declared_value_rate"),
              key: "values_rate",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              show: ({ formData }) => {
                if (formData.isCharges == 1) {
                  return true;
                }
              },
              placeholder() {
                return this.$t("enter") + this.$t("declared_value_rate");
              }
            },
            {
              name: () =>
                this.$t("ddp_price") + "(" + this.$t("per_ticket") + ")",
              key: "ddp_price",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              show: ({ formData }) => {
                if (formData.isCharges == 1) {
                  return true;
                }
              },
              bind: {
                min: 0,
                style: "width:100%"
              },
              placeholder() {
                return this.$t("enter") + this.$t("ddp_price");
              }
            },
            {
              name: () => this.$t("air_price") + "(" + this.$t("eachKG") + ")",
              key: "air_price",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("air_price");
              }
            },
            {
              name: () =>
                this.$t("destroy_price") + "(" + this.$t("per_ticket") + ")",
              key: "destroy_price",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("destroy_price");
              }
            },
            {
              name: () =>
                this.$t("send_price") + "(" + this.$t("per_ticket") + ")",
              key: "send_price",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("send_price");
              }
            },
            {
              name: () => this.$t("VAT_charges"),
              key: "vat_fee_rate",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("VAT_charges");
              }
            },
            {
              name: () =>
                this.$t("postal_usage_fee") + "(" + this.$t("per_ticket") + ")",
              key: "airway_price",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("postal_usage_fee");
              }
            },
            {
              name: () => this.$t("billFee"),
              key: "extract_price",
              component: "Input",
              bind: {
                min: 0,
                style: "width:100%",
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("billFee");
              }
            },
            {
              name: () => this.$t("clearance_fee_type"),
              key: "extract_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("clearance_fee_type");
              },
              options: []
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            },
            {
              key: "continued"
            }
          ],
          table: {
            group: {
              title: this.$t("continueWeight")
            },
            config: {
              height: 200
            },
            fields: [
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                // width({ field }) {
                //   return field.list.length * 40 + 40;
                // },
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning"
                    },
                    icon: "md-add",
                    disabled({ rowIndex }) {
                      return rowIndex != 0;
                    }
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    disabled() {
                      return this.list.length == 1;
                    }
                  }
                ],
                methods: {
                  add() {
                    let button = {
                      lower_weight: "",
                      upper_weight: "",
                      price: "",
                      weight: ""
                    };
                    this.getModal("add").list.unshift(button);
                    let data = JSON.parse(
                      JSON.stringify(this.getModal("add").params)
                    );
                    this.getModal("add").updateFormData(data);
                  },
                  delete({ rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.getModal("add").list.splice(rowIndex, 1);
                      }
                    });
                  }
                }
              },
              {
                name: () => this.$t("sll_weight"),
                align: "center",
                key: "lower_weight",
                placeholder() {
                  return this.$t("select") + this.$t("sll_weight");
                },
                component: "Input",
                bind: {
                  min: 0,
                  style: "width:100%",
                  type: "number"
                }
              },
              {
                name: () => this.$t("big_weight"),
                align: "center",
                key: "upper_weight",
                placeholder() {
                  return this.$t("select") + this.$t("big_weight");
                },
                component: "Input",
                bind: {
                  min: 0,
                  style: "width:100%",
                  type: "number"
                }
              },
              {
                name: () => this.$t("numMin") + this.$t("orderNums"),
                align: "center",
                key: "min_order",
                placeholder() {
                  return (
                    this.$t("select") + this.$t("numMin") + this.$t("orderNums")
                  );
                },
                component: "Input",
                bind: {
                  min: 0,
                  style: "width:100%",
                  type: "number"
                },
                show: () => {
                  // console.log(this);
                  return (
                    this.$refs["table"].getModal("add").$refs["form"].formData
                      .is_special == 1
                  );
                }
              },
              {
                name: () => this.$t("numMax") + this.$t("orderNums"),
                align: "center",
                key: "max_order",
                placeholder() {
                  return (
                    this.$t("select") + this.$t("numMax") + this.$t("orderNums")
                  );
                },
                component: "Input",
                bind: {
                  min: 0,
                  style: "width:100%",
                  type: "number"
                },
                show: () => {
                  // console.log(this);
                  return (
                    this.$refs["table"].getModal("add").$refs["form"].formData
                      .is_special == 1
                  );
                }
              },
              {
                name: () => this.$t("billing_price"),
                align: "center",
                key: "price",
                placeholder() {
                  return this.$t("select") + this.$t("billing_price");
                },
                component: "Input",
                bind: {
                  min: 0,
                  style: "width:100%",
                  type: "number"
                }
              },
              {
                name: () => this.$t("billing_unit"),
                align: "center",
                key: "weight",
                placeholder() {
                  return this.$t("select") + this.$t("billing_unit");
                },
                component: "Input",
                bind: {
                  min: 0,
                  style: "width:100%",
                  type: "number"
                },
                show: () => {
                  // console.log(this);
                  return (
                    this.$refs["table"].getModal("add").$refs["form"].formData
                      .is_special == 0
                  );
                }
              }
            ]
          }
        },
        continue: {
          config: {
            modalBind: {
              width: "80%"
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          // btns: {
          //   list: [
          //     {
          //       name: () => this.$t("export"),
          //       type: "export",
          //       fnName: "export",
          //       size: "small",
          //       disabled() {
          //         return !this.selectAll.length;
          //       },
          //       bind: {
          //         icon: "md-arrow-down",
          //         type: "primary"
          //       }
          //     }
          //   ],
          //   methods: {
          //     export() {
          //       this.$page.exportExc({
          //         data: this.list,
          //         fields: this.table.fields,
          //         name: this.title
          //       });
          //     }
          //   }
          // },
          table: {
            footer: false,
            config: {
              align: "center",
              height: 600
            },
            fields: [
              // {
              //   type: "checkbox",
              //   align: "center",
              //   width: 60
              // },
              {
                name: () => this.$t("sll_weight"),
                key: "lower_weight",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("big_weight"),
                key: "upper_weight",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("numMin") + this.$t("orderNums"),
                key: "min_order",
                align: "center",
                minWidth: 100,
                show: function() {
                  return this.$modal.params.is_special == 1;
                }
              },
              {
                name: () => this.$t("numMax") + this.$t("orderNums"),
                key: "max_order",
                align: "center",
                minWidth: 100,
                show: function() {
                  return this.$modal.params.is_special == 1;
                }
              },
              {
                name: () => this.$t("billing_price"),
                key: "price",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("billing_unit"),
                key: "weight",
                align: "center",
                minWidth: 100,
                show: function() {
                  return this.$modal.params.is_special == 0;
                }
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            config: {
              label({ row, field }) {
                return this.$t(row.label);
              }
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["CHANNEL_COST_TYPE"])).data
                  .payload["CHANNEL_COST_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "start_time",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  // return time.getTime() > Date.now();
                  return false;
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.start_time = searchForm.start_time
                  ? this.$page.format.timeFormat(searchForm.start_time)
                  : "";
              }
            }
          },
          {
            key: "end_time",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  // return time.getTime() > Date.now();
                  return false;
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.end_time);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["end_time"] = time;
                }
              }
            }
          },

          {
            key: "agent_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            clearable: true,
            options: [],
            config: { label: "agent_name", value: "id" }
          },
          {
            name: () => this.$t("from_country"),
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            options: [],
            config: { label: "code", value: "code" }
          },
          {
            name: () => this.$t("target_country"),
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            options: [],
            config: { label: "code", value: "code" },
            methods: {
              "on-change"({ searchForm, fields, value }) {
                console.log(arguments);
                fields.forEach(async item => {
                  if (item.key == "division") {
                    searchForm["division"] = "";
                    // if (searchForm.to_country) {
                    item.options = (
                      await this.handleRequestMethods("getFinaDivision", {
                        country: searchForm.to_country
                      })
                    ).payload;
                    // } else {
                    //   item.options = [];
                    // }
                  }
                  this.$forceUpdate();
                });
              }
            }
          },
          {
            name: () => this.$t("division"),
            key: "division",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("division");
            },
            options: []
          },
          {
            name: () => this.$t("cod_type_txt"),
            key: "cod_type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("cod_type_txt");
            },
            options: []
          },
          {
            name: () => this.$t("pod_type_txt"),
            key: "pod_type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("pod_type_txt");
            },
            options: []
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 618
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, function() {
                this.list = [
                  {
                    lower_weight: "",
                    upper_weight: "",
                    price: "",
                    weight: ""
                  }
                ];
                this.setTitle(this.$t("add"));
                this.type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("costName"),
          key: "title",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("enableTime"),
          key: "start_time",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("deadline"),
          key: "end_time",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("agentName"),
          key: "agent",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("billingCurrency"),
          key: "currency",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("firstWeight"),
          key: "first_weight",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("firstWeightFreight"),
          key: "first_weight_price",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("VAT_charges"),
          key: "vat_fee_rate",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("postal_usage_fee"),
          key: "airway_price",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("billFee"),
          key: "extract_price",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("air_price"),
          key: "air_price",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("declared_value"),
          key: "values_limit",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("declared_value_rate"),
          key: "values_rate",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("ddp_price"),
          key: "ddp_price",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("destroy_price"),
          key: "destroy_price",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("send_price"),
          key: "send_price",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("division_txt"),
          key: "division_txt",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("cod_type_txt"),
          key: "cod_type_txt",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("pod_type_txt"),
          key: "pod_type_txt",
          align: "center",
          minWidth: 100
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("continueWeight"),
              type: "continueWeight",
              fnName: "continueWeight",
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 619
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error"
              },
              id: 620
            },
						{
						  name: this.$t("updateLog"),
						  type: "log",
						  fnName: "log",
						  bind: {
						    type: "primary"
						  },
							id:1042
						}
          ],
          methods: {
						log({row}){
							this
							  .getModal("showDetails")
							  .setTitle(this.$t("detail"));
							this.getModal("showDetails").open({ row }, function () {
							  let data = {
							    relation_id: row.id,
									type:7
							  };
							  this.pageConfig.data = data;
							  this.getList(data);
							});
						},
            continueWeight({ row }) {
              this.getModal("continue").open(row, function() {
                this.list = row.continued;
                this.setTitle(this.$t("continueWeight"));
              });
            },
            update({ row }) {
              let data = JSON.parse(JSON.stringify(row));
              this.getModal("add").open(data, function() {
                this.list = data.continued;
                if (!data.continued.length)
                  this.list = [
                    {
                      lower_weight: "",
                      upper_weight: "",
                      price: "",
                      weight: ""
                    }
                  ];
                this.type = "update";
                this.fields.forEach(async item => {
                  if (item.key == "division") {
                    item.options = (
                      await this.$page.handleRequestMethods("getFinaDivision", {
                        country: row.to_country
                      })
                    ).payload;
                  }
                });
                this.setTitle(this.$t("update"));
              });
              // });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id, true).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  methods: {
    SelChange(val) {
      let list = this.$refs["table"].getModal("rate").list;
      this.options.forEach(el => {
        el.disabled = false;
        list.forEach(ele => {
          if (el.id == ele.currency_id) {
            el.disabled = true;
          }
        });
      });
    }
  },
  async mounted() {
    let configData = await getConfig();
    let division = await getFinaDivision();
    let fromCountry = await getCountry({ allow_depart: 1 });
    let toCountry = await getCountry({ allow_arrive: 1 });
    let agentData = await getAgent();
    this.modals.add.fields.forEach(item => {
      // if (item.key === "division")
      //   item.options = configData.data.payload.division;
      if (item.key === "cod_type")
        item.options = configData.data.payload.cod_type;
      if (item.key === "pod_type")
        item.options = configData.data.payload.pod_type;
      if (item.key === "agent_id") item.options = agentData.data.payload.rows;
      if (item.key === "from_country")
        item.options = fromCountry.data.payload.rows;
      if (item.key === "to_country") item.options = toCountry.data.payload.rows;
      if (item.key === "extract_type")
        item.options = configData.data.payload.extract_type;
    });
    this.header.searchs.forEach(item => {
      if (item.key === "division") item.options = division.data.payload;
      if (item.key === "cod_type")
        item.options = configData.data.payload.cod_type;
      if (item.key === "pod_type")
        item.options = configData.data.payload.pod_type;
      if (item.key === "agent_id") item.options = agentData.data.payload.rows;
      if (item.key === "from_country")
        item.options = fromCountry.data.payload.rows;
      if (item.key === "to_country") item.options = toCountry.data.payload.rows;
    });
  }
};
</script>
